import { motion } from 'framer-motion';

// Voice Waves Component
export const VoiceWaves = ({ volume }) => (
  <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <motion.div
        key={i}
        className="w-1 bg-primary rounded-full"
        animate={{
          height: Math.random() * 20 + 10,
          opacity: volume / 100,
        }}
        transition={{
          duration: 0.2,
          repeat: Infinity,
        }}
      />
    ))}
  </div>
);
